import React, { useState, useCallback, useEffect } from "react";
import Dropdown from "../components/DesignSystem/dropdown_autocomplete";
import { useIsMounted } from "../utils/customHooks";
import Button from "../components/DesignSystem/button";
import axios, { AxiosRequestConfig } from "axios";
import { API_URL } from "../utils/apiConstants";
import AuthService from "../services/auth.service";
import { toasterSuccess } from "../utils/methods";

const adminScripts = [
  {
    name: "Get Port Details",
    route: "port-details",
    params: ["nrID"],
    type: "GET",
    getData: (res: any) => {
      if (res.data.success) toasterSuccess("Check Console");
      return [res.data.data];
    },
  },
  {
    name: "Add Calient Switch",
    route: "create-calient",
    params: ["management_ip", "ne_username", "ne_password", "name", "street", "city", "state", "zip", "country", "longitude", "latitude", "organization_id", "leased_organization_id"],
    type: "POST",
    getData: (res: any) => {
      if (res.data.success) {
        toasterSuccess("Calient Created");
      }
    },
  },
];

const AdminScripts: React.FC = () => {
  const isComponentMounted = useIsMounted();
  const [scriptSelected, setScriptSelected] = useState(adminScripts[0].name);
  const [input, setInput] = useState(adminScripts[0].name);
  const script = React.useMemo(() => {
    return adminScripts.find((obj) => obj.name === scriptSelected);
  }, [scriptSelected]);
  const [result, setResult] = React.useState<any>();
  const [params0, setParams0] = React.useState("");
  const [params1, setParams1] = React.useState("");
  const [params2, setParams2] = React.useState("");
  const [params3, setParams3] = React.useState("");
  const [params4, setParams4] = React.useState("");
  const [params5, setParams5] = React.useState("");
  const [params6, setParams6] = React.useState("");
  const [params7, setParams7] = React.useState("");
  const [params8, setParams8] = React.useState("");
  const [params9, setParams9] = React.useState("");
  const [params10, setParams10] = React.useState("");
  const [params11, setParams11] = React.useState("");
  const [params12, setParams12] = React.useState("");
  const [params13, setParams13] = React.useState("");
  const [params14, setParams14] = React.useState("");
  const onSelectScript = useCallback(
    (scr) => {
      setScriptSelected(scr);
      setParams0("");
      setParams1("");
      setParams2("");
      setParams3("");
      setParams4("");
      setParams5("");
      setParams6("");
      setParams7("");
      setParams8("");
      setParams9("");
      setParams10("");
      setParams11("");
      setParams12("");
      setParams13("");
      setParams14("");
      setResult(null);
    },
    [scriptSelected]
  );

  const onSubmit = useCallback(() => {
    if (!script) return;

    let headersList = {
      Accept: "*/*",
      Authorization: AuthService.getToken(),
    };

    let params: string[] = [];
    if (params0) {
      params.push(`${script.params[0]}=${params0}`);
    }
    if (params1) {
      params.push(`${script.params[1]}=${params1}`);
    }
    if (params2) {
      params.push(`${script.params[2]}=${params2}`);
    }
    if (params3) {
      params.push(`${script.params[3]}=${params3}`);
    }
    if (params4) {
      params.push(`${script.params[4]}=${params4}`);
    }
    if (params5) {
      params.push(`${script.params[5]}=${params5}`);
    }
    if (params6) {
      params.push(`${script.params[6]}=${params6}`);
    }
    if (params7) {
      params.push(`${script.params[7]}=${params7}`);
    }
    if (params8) {
      params.push(`${script.params[8]}=${params8}`);
    }
    if (params9) {
      params.push(`${script.params[9]}=${params9}`);
    }
    if (params10) {
      params.push(`${script.params[10]}=${params10}`);
    }
    if (params11) {
      params.push(`${script.params[11]}=${params11}`);
    }
    if (params12) {
      params.push(`${script.params[12]}=${params12}`);
    }
    if (params13) {
      params.push(`${script.params[13]}=${params13}`);
    }
    if (params14) {
      params.push(`${script.params[14]}=${params14}`);
    }
    let finalParams = "";
    if (params.length > 0) {
      finalParams = `?${params.join("&")}`;
    }
    let reqOptions: any = {
      url: `${API_URL}api/admin-scripts/${script.route}${finalParams}`,
      method: script.type,
      headers: headersList,
    };

    axios
      .request(reqOptions)
      .then((res) => {
        if (!isComponentMounted) return;
        console.log(script.getData(res));
      })
      .catch((err) => console.log(err));
  }, [script, params0, params1, params2, params3, params4, params5, params6, params7, params8, params9, params10, params11, params12, params13, params14]);

  return (
    <div className="admin-scripts" style={{ color: "white", display: "flex", flexDirection: "column" }}>
      <h1>Select Script</h1>
      <div style={{ width: "100%" }}>
        <Dropdown
          value={scriptSelected}
          inputValue={input}
          options={adminScripts.map((item) => item.name)}
          onInputChange={setInput}
          onChange={onSelectScript}
        />
      </div>
      <span style={{ paddingBottom: "10px" }} />
      {script && script.params.length > 0 && (
        <div>
          <h2>Params:</h2>
          {script.params.length > 0 && (
            <div>
              <h3>{script.params[0]}</h3>
              <input name={script.params[0]} className="port-name d-input" value={params0} onChange={(e) => setParams0(e.target.value)} />

              <span style={{ paddingBottom: "10px" }} />
            </div>
          )}
          {script.params.length > 1 && (
            <div>
              <h3>{script.params[1]}</h3>
              <input name={script.params[1]} className="port-name d-input" value={params1} onChange={(e) => setParams1(e.target.value)} />

              <span style={{ paddingBottom: "10px" }} />
            </div>
          )}
          {script.params.length > 2 && (
            <div>
              <h3>{script.params[2]}</h3>
              <input name={script.params[2]} className="port-name d-input" value={params2} onChange={(e) => setParams2(e.target.value)} />

              <span style={{ paddingBottom: "10px" }} />
            </div>
          )}
          {script.params.length > 3 && (
            <div>
              <h3>{script.params[3]}</h3>
              <input name={script.params[3]} className="port-name d-input" value={params3} onChange={(e) => setParams3(e.target.value)} />

              <span style={{ paddingBottom: "10px" }} />
            </div>
          )}
          {script.params.length > 4 && (
            <div>
              <h3>{script.params[4]}</h3>
              <input name={script.params[4]} className="port-name d-input" value={params4} onChange={(e) => setParams4(e.target.value)} />

              <span style={{ paddingBottom: "10px" }} />
            </div>
          )}
          {script.params.length > 5 && (
            <div>
              <h3>{script.params[5]}</h3>
              <input name={script.params[5]} className="port-name d-input" value={params5} onChange={(e) => setParams5(e.target.value)} />

              <span style={{ paddingBottom: "10px" }} />
            </div>
          )}
          {script.params.length > 6 && (
            <div>
              <h3>{script.params[6]}</h3>
              <input name={script.params[6]} className="port-name d-input" value={params6} onChange={(e) => setParams6(e.target.value)} />

              <span style={{ paddingBottom: "10px" }} />
            </div>
          )}
          {script.params.length > 7 && (
            <div>
              <h3>{script.params[7]}</h3>
              <input name={script.params[7]} className="port-name d-input" value={params7} onChange={(e) => setParams7(e.target.value)} />

              <span style={{ paddingBottom: "10px" }} />
            </div>
          )}
          {script.params.length > 8 && (
            <div>
              <h3>{script.params[8]}</h3>
              <input name={script.params[8]} className="port-name d-input" value={params8} onChange={(e) => setParams8(e.target.value)} />

              <span style={{ paddingBottom: "10px" }} />
            </div>
          )}
          {script.params.length > 9 && (
            <div>
              <h3>{script.params[9]}</h3>
              <input name={script.params[9]} className="port-name d-input" value={params9} onChange={(e) => setParams9(e.target.value)} />

              <span style={{ paddingBottom: "10px" }} />
            </div>
          )}
          {script.params.length > 10 && (
            <div>
              <h3>{script.params[10]}</h3>
              <input name={script.params[10]} className="port-name d-input" value={params10} onChange={(e) => setParams10(e.target.value)} />

              <span style={{ paddingBottom: "10px" }} />
            </div>
          )}
          {script.params.length > 11 && (
            <div>
              <h3>{script.params[11]}</h3>
              <input name={script.params[11]} className="port-name d-input" value={params11} onChange={(e) => setParams11(e.target.value)} />

              <span style={{ paddingBottom: "10px" }} />
            </div>
          )}
          {script.params.length > 12 && (
            <div>
              <h3>{script.params[12]}</h3>
              <input name={script.params[12]} className="port-name d-input" value={params12} onChange={(e) => setParams12(e.target.value)} />

              <span style={{ paddingBottom: "10px" }} />
            </div>
          )}
          {script.params.length > 13 && (
            <div>
              <h3>{script.params[13]}</h3>
              <input name={script.params[13]} className="port-name d-input" value={params13} onChange={(e) => setParams13(e.target.value)} />

              <span style={{ paddingBottom: "10px" }} />
            </div>
          )}
          {script.params.length > 14 && (
            <div>
              <h3>{script.params[14]}</h3>
              <input name={script.params[14]} className="port-name d-input" value={params14} onChange={(e) => setParams14(e.target.value)} />

              <span style={{ paddingBottom: "10px" }} />
            </div>
          )}
        </div>
      )}
      <Button variant={"search"} text="Execute Script" onClick={() => onSubmit()} />
    </div>
  );
};

export default AdminScripts;
